(() => {
  const init = (root = document) => {
    root.querySelectorAll('.menu-toggle:not([data-ready])').forEach(button => {
      button.dataset.ready = 'true';
      const nav = document.getElementById(button.getAttribute('aria-controls'));
      button.addEventListener('click', () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        nav.hidden = !open;
      });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !nav.hidden) { nav.hidden = true; button.setAttribute('aria-expanded', 'false'); button.focus(); }
      });
    });
    root.querySelectorAll('.hero:not([data-ready])').forEach(hero => {
      hero.dataset.ready = 'true';
      const slides = [...hero.querySelectorAll('[data-slide]')];
      let current = 0;
      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => { slide.hidden = i !== current; slide.classList.toggle('active', i === current); });
        hero.querySelectorAll('[data-go]').forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
      };
      hero.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click', () => show(current + Number(b.dataset.step))));
      hero.querySelectorAll('[data-go]').forEach(b => b.addEventListener('click', () => show(Number(b.dataset.go))));
      // Deliberate manual rotation: readable captions and no unexpected motion.
    });
    root.querySelectorAll('.product-detail:not([data-ready])').forEach(detail => {
      detail.dataset.ready = 'true';
      const showMedia = id => {
        if (!id || !detail.querySelector(`[id="${id}"]`)) return;
        detail.querySelectorAll('.product-media').forEach(media => {
          media.hidden = media.id !== id;
          if (media.hidden) media.querySelectorAll('video').forEach(video => video.pause());
        });
        detail.querySelectorAll('[data-media]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.media === id)));
      };
      detail.querySelectorAll('button[data-media]').forEach(button => button.addEventListener('click', () => showMedia(button.dataset.media)));
      const variants = detail.querySelector('[data-variant]');
      variants?.addEventListener('change', () => {
        const option = variants.selectedOptions[0];
        const button = detail.querySelector('.add-to-cart');
        const available = option.dataset.available === 'true';
        button.disabled = !available; button.textContent = available ? 'Add to cart' : 'Sold out';
        detail.querySelector('[data-price]').textContent = option.dataset.price;
        const compare = detail.querySelector('[data-compare]');
        if (compare) compare.hidden = true;
        showMedia(option.dataset.media);
        const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
      });
    });
  };
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('[data-slide]');
    if (slide) slide.closest('.hero').querySelector(`[data-go="${slide.dataset.slide}"]`)?.click();
  });
})();
